import { fetchFromAPI } from 'utils/api';

export const saveUserDevice = (resource) => {
  return fetchFromAPI('/user_devices/batch', { method: 'post', body: JSON.stringify({ resource }) })
    .catch((response) => {
      throw response;
    });
};
